const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNzg4LCJjb25ncmVzc0lkIjoxNDA1LCJkYXRlIjoiMjAyMy0wMi0yMFQwNzoxMzo1Ni45OThaIiwiaWF0IjoxNjc2ODc3MjM2fQ.2vbd1TO27j4A_TZoQxvSsCVjfejrEn4qyO1ziXBYlz8';
const PLANNER_API_URL = 'https://ueg2023.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNzg5LCJjb25ncmVzc0lkIjoxNDA1LCJkYXRlIjoiMjAyMy0wMi0yMFQwNzoxNDoyMS4yMTNaIiwiaWF0IjoxNjc2ODc3MjYxfQ.e0NpgdwkYjOOd4ZuH77Cy1Ba6qKDQfAOgoM8DO_cifU';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1405;
const SUBMISSION_API_URL = 'https://ueg2023.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}
